<template>
    <div class="unit-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-collection-tag"></i>
                    <span>单元管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="所属年级">
                    <el-select clearable v-model="query.gradeId" placeholder="全部年级" style="width: 160px" @change="handleFilterGradeChange">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分册">
                    <el-select clearable v-model="query.volume" placeholder="全部分册" style="width: 120px">
                        <el-option v-for="item in volumeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单元名称">
                    <el-input clearable v-model="query.unitName" placeholder="请输入单元名称" style="width: 160px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="success" icon="el-icon-upload2" @click="openImportDialog">批量导入</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增单元</el-button>
                </div>
            </div>
            <el-table
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="80" align="center"/>
                <el-table-column prop="gradeName" label="所属年级" width="120" show-overflow-tooltip/>
                <el-table-column prop="volume" label="分册" width="100" align="center"/>
                <el-table-column prop="unitNumber" label="单元编号" width="100" align="center"/>
                <el-table-column prop="unitName" label="单元名称" show-overflow-tooltip/>
                <el-table-column prop="description" label="描述" min-width="150" show-overflow-tooltip/>
                <el-table-column prop="sort" label="排序" width="80" align="center"/>
                <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
                            {{ scope.row.status === 1 ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="250" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="btnInsert(scope.row)">编辑</el-button>
                            <el-button type="warning" size="mini" :icon="scope.row.status === 1 ? 'el-icon-close' : 'el-icon-check'" @click="btnToggleStatus(scope.row)">
                                {{ scope.row.status === 1 ? '禁用' : '启用' }}
                            </el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="btnDelete(scope.row.id)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                style="margin-top: 16px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                :page-size="query.pageSize"
                :current-page="query.currentPage"
                :total="total">
            </el-pagination>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="560px"
            class="unit-dialog eco-dialog"
            :show-close="false">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-collection-tag"></i></div>
                    <div>
                        <div class="batch-header-title">{{ dialogTitle }}</div>
                        <div class="batch-header-desc">选择年级与分册后，单元编号与名称自动填充</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="closeDialog"></i>
            </div>
            <el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
                <el-form-item label="所属年级" prop="gradeId">
                    <el-select v-model="formData.gradeId" @change="handleDialogGradeChange" placeholder="请选择年级" style="width: 100%">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分册" prop="volume">
                    <el-select v-model="formData.volume" @change="handleGradeOrVolumeChange" placeholder="请选择分册" style="width: 100%">
                        <el-option v-for="item in dialogVolumeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单元名称" prop="unitName">
                    <el-input v-model="formData.unitName" placeholder="例如：Unit 1 My School"></el-input>
                </el-form-item>
                <el-form-item label="单元编号" prop="unitNumber">
                    <el-input-number v-model="formData.unitNumber" :min="1" placeholder="请输入单元编号"></el-input-number>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" v-model="formData.description" placeholder="请输入描述" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model="formData.sort" :min="0" placeholder="请输入排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button class="unit-submit-btn" type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
            </div>
        </el-dialog>

        <!-- 批量导入对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="importVisible"
            width="560px"
            class="unit-import-dialog eco-dialog"
            :show-close="false">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-upload2"></i></div>
                    <div>
                        <div class="batch-header-title">批量导入单元</div>
                        <div class="batch-header-desc">文件名体现年级与分册，每个 sheet 即一个单元</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="closeImportDialog"></i>
            </div>

            <el-alert type="warning" :closable="false" class="import-tip">
                <template slot="title">
                    <div class="import-tip-title">文件命名规范</div>
                    <div class="import-tip-body">
                        文件名需包含「年级 + 分册」，兼容小学 / 初中 / 高中、上下册或必修，例如：
                        <br/>· <b>外研版三起点_三年级上册_单词表.xlsx</b>（识别为：三年级 / 上册）
                        <br/>· <b>3年级下册.xlsx</b>（识别为：3年级 / 下册）
                        <br/>· <b>高一必修一.xlsx</b>（识别为：高一 / 必修一）
                        <br/>Excel 中<b>每个 sheet（按 1→n 顺序）</b>即一个单元，<b>sheet 名即单元名称</b>。
                        唯一约束为「年级 + 分册 + 单元名称」，已存在则跳过并提示。
                    </div>
                </template>
            </el-alert>

            <el-upload
                class="import-uploader"
                drag
                action="#"
                :auto-upload="false"
                :show-file-list="true"
                :limit="1"
                accept=".xls,.xlsx"
                :on-change="handleImportFileChange"
                :on-remove="handleImportFileRemove"
                ref="importUploader">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将 Excel 文件拖到此处，或 <em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">仅支持 .xls / .xlsx 格式</div>
            </el-upload>

            <div v-if="importResult" class="import-result">
                <el-divider content-position="left">导入结果</el-divider>
                <p>识别年级分册：<b>{{ importResult.gradeName }} / {{ importResult.volume }}</b></p>
                <p>共解析 <b>{{ importResult.total }}</b> 个单元，新增 <b class="ok">{{ importResult.inserted }}</b> 个，跳过 <b class="skip">{{ importResult.skipped }}</b> 个</p>
                <div v-if="importResult.skipList && importResult.skipList.length" class="import-skip-list">
                    <div v-for="(item, idx) in importResult.skipList" :key="idx" class="import-skip-item">
                        <i class="el-icon-warning"></i> {{ item }}
                    </div>
                </div>
            </div>

            <div slot="footer">
                <el-button @click="closeImportDialog">取消</el-button>
                <el-button class="unit-submit-btn" type="primary" @click="submitImport" :loading="importLoading" :disabled="!importFile">开始导入</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {reqUnitPage, reqUnitInsert, reqUnitUpdate, reqUnitDelete, reqUnitsByGradeAndVolume, reqVolumeOptions, reqImportUnits} from '@/api/education/unit'
import {reqGradePage} from '@/api/education/grade'

export default {
    name: 'Unit',
    data() {
        return {
            list: [],
            total: 0,
            gradeList: [],
            volumeOptions: [],
            dialogVolumeOptions: [],
            tableLoading: false,
            submitLoading: false,
            query: {
                currentPage: 1,
                pageSize: 10,
                unitName: '',
                gradeId: null,
                volume: ''
            },
            dialogVisible: false,
            dialogTitle: '',
            formData: {
                id: null,
                unitName: '',
                unitNumber: 1,
                gradeId: null,
                volume: '',
                description: '',
                sort: 0,
                status: 1
            },
            rules: {
                unitName: [
                    {required: true, message: '请输入单元名称', trigger: 'blur'}
                ],
                unitNumber: [
                    {required: true, message: '请输入单元编号', trigger: 'blur'}
                ],
                gradeId: [
                    {required: true, message: '请选择所属年级', trigger: 'change'}
                ],
                volume: [
                    {required: true, message: '请选择分册', trigger: 'change'}
                ]
            },
            importVisible: false,
            importLoading: false,
            importFile: null,
            importResult: null
        }
    },
    created() {
        this.loadGradeList()
        // 从URL参数获取筛选条件
        const { gradeId, volume } = this.$route.query
        if (gradeId) {
            this.query.gradeId = Number(gradeId)
        }
        if (volume) {
            this.query.volume = volume
        }
        this.load()
    },
    methods: {
        async loadGradeList() {
            try {
                const data = await reqGradePage({currentPage: 1, pageSize: 100})
                this.gradeList = data.records || []
            } catch (e) {
                console.error('加载年级列表失败:', e)
            }
        },
        // 加载分册选项（根据年级/全局）
        async loadVolumeOptions(gradeId) {
            try {
                const res = await reqVolumeOptions(gradeId)
                const list = (res && Array.isArray(res)) ? res : []
                return list.map(v => ({ label: v, value: v }))
            } catch (e) {
                console.error('加载分册选项失败:', e)
                return []
            }
        },
        // 筛选表单年级变化：加载对应分册选项
        async handleFilterGradeChange(gradeId) {
            if (gradeId) {
                this.volumeOptions = await this.loadVolumeOptions(gradeId)
            } else {
                this.volumeOptions = []
            }
        },
        // 对话框年级变化：加载对应分册选项 + 原有自动填充逻辑
        async handleDialogGradeChange(gradeId) {
            if (gradeId) {
                this.dialogVolumeOptions = await this.loadVolumeOptions(gradeId)
                // 清空分册（让用户重新选择）
                this.formData.volume = ''
            } else {
                this.dialogVolumeOptions = []
            }
            // 保留原有自动填充逻辑
            this.handleGradeOrVolumeChange()
        },
        // 处理年级或分册变化，自动填充单元名称和编号
        async handleGradeOrVolumeChange() {
            // 只有在新增模式下才自动填充
            if (this.formData.id) {
                return
            }

            // 如果年级和分册都已选择，查询该年级分册下的单元列表
            if (this.formData.gradeId && this.formData.volume) {
                try {
                    const units = await reqUnitsByGradeAndVolume(this.formData.gradeId, this.formData.volume)

                    if (units && units.length > 0) {
                        // 找到最大的单元编号（编号是所有单元的最大号+1）
                        const maxUnitNumber = Math.max(...units.map(u => u.unitNumber || 0))
                        this.formData.unitNumber = maxUnitNumber + 1

                        // 单元名称：统计已有单元中名为 "Unit N" 的数量，从1开始递增
                        // 例如已有"欢迎单元"（不是Unit N格式），则新单元名=Unit 1
                        const unitNameCount = units.filter(u => u.unitName && /^Unit\s+\d+$/i.test(u.unitName)).length
                        this.formData.unitName = `Unit ${unitNameCount + 1}`
                    } else {
                        // 如果没有单元，从1开始
                        this.formData.unitNumber = 1
                        this.formData.unitName = 'Unit 1'
                    }
                } catch (error) {
                    console.error('获取单元列表失败:', error)
                    // 失败时设置默认值
                    this.formData.unitNumber = 1
                    this.formData.unitName = 'Unit 1'
                }
            } else {
                // 如果年级或分册未选择，清空单元名称和编号
                this.formData.unitNumber = 1
                this.formData.unitName = ''
            }
        },
        async load() {
            this.tableLoading = true
            try {
                const data = await reqUnitPage(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载单元列表失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                currentPage: 1,
                pageSize: 10,
                unitName: '',
                gradeId: null,
                volume: ''
            }
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        closeDialog() {
            if (this.$refs.formData) {
                this.$refs.formData.clearValidate()
            }
            this.dialogVisible = false
        },
        btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑单元'
                this.formData = JSON.parse(JSON.stringify(row))
            } else {
                this.dialogTitle = '新增单元'
                this.formData = {
                    id: null,
                    unitName: '',
                    unitNumber: 1,
                    gradeId: null,
                    volume: '',
                    description: '',
                    sort: 0,
                    status: 1
                }
            }
            this.$nextTick(() => {
                if (this.$refs.formData) {
                    this.$refs.formData.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        async btnToggleStatus(row) {
            const action = row.status === 1 ? '禁用' : '启用'
            try {
                await this.$confirm(`确定要${action}该单元吗？`, '操作确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqUnitUpdate({
                    id: row.id,
                    status: row.status === 1 ? 0 : 1
                })
                this.$message.success(`${action}成功`)
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || `${action}失败`)
                }
            }
        },
        async btnDelete(id) {
            try {
                await this.$confirm('此操作将永久删除该单元，是否继续？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqUnitDelete(id)
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || '删除失败')
                }
            }
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (!valid) return

                this.submitLoading = true
                try {
                    await (this.formData.id
                        ? reqUnitUpdate(this.formData)
                        : reqUnitInsert(this.formData))
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        // ===== 批量导入 =====
        openImportDialog() {
            this.importVisible = true
            this.importFile = null
            this.importResult = null
            if (this.$refs.importUploader) {
                this.$refs.importUploader.clearFiles()
            }
        },
        closeImportDialog() {
            this.importVisible = false
            this.importFile = null
            this.importResult = null
        },
        handleImportFileChange(file) {
            const isExcel = /\.(xls|xlsx)$/.test(file.name.toLowerCase())
            if (!isExcel) {
                this.$message.error('仅支持 .xls / .xlsx 格式的 Excel 文件')
                this.$refs.importUploader.clearFiles()
                this.importFile = null
                return
            }
            this.importFile = file.raw
            this.importResult = null
        },
        handleImportFileRemove() {
            this.importFile = null
            this.importResult = null
        },
        async submitImport() {
            if (!this.importFile) {
                this.$message.warning('请先选择 Excel 文件')
                return
            }
            const formData = new FormData()
            formData.append('file', this.importFile)
            this.importLoading = true
            try {
                const res = await reqImportUnits(formData)
                this.importResult = res
                if (res.inserted > 0) {
                    this.$message.success(`成功导入 ${res.inserted} 个单元`)
                    this.load()
                } else if (res.skipped > 0 && res.inserted === 0) {
                    this.$message.info('全部单元已存在，无新增')
                } else {
                    this.$message.info('未解析到可导入的单元')
                }
            } catch (e) {
                this.$message.error(e.message || '导入失败')
            } finally {
                this.importLoading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.unit-page {
    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                margin-right: 6px;
                color: #409EFF;
            }

            .el-divider {
                margin: 0 10px;
                background-color: #dcdfe6;
            }

            .header-sub {
                font-weight: 400;
                font-size: 13px;
                color: #909399;
            }

            .total-badge {
                margin-left: 16px;
                font-weight: 400;
                font-size: 13px;
                color: #606266;

                b {
                    color: #409EFF;
                }
            }
        }
    }

    .filter-form {
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
    }

    ::v-deep .el-table {
        th.el-table__cell {
            background-color: #fafafa;
            color: #606266;
            font-weight: 600;
        }
    }
}

.unit-dialog {
    ::v-deep .el-dialog {
        .el-dialog__body {
            padding: 24px;
        }

        .el-dialog__footer {
            padding: 14px 24px;
            border-top: 1px solid #e3f1ec;
        }
    }

    .unit-submit-btn {
        background-color: #2e8b74;
        border-color: #2e8b74;

        &:hover,
        &:focus {
            background-color: #4fae93;
            border-color: #4fae93;
        }

        &.is-loading {
            background-color: #2e8b74;
            border-color: #2e8b74;
        }
    }

    ::v-deep .el-button--default {
        &:hover,
        &:focus {
            color: #2e8b74;
            border-color: #4fae93;
        }
    }
}

@media (max-width: 768px) {
    .unit-page {
        .filter-card,
        .table-card {
            margin: 8px 6px;
        }
    }
}

// 批量导入弹窗
.unit-import-dialog {
    ::v-deep .el-dialog {
        .el-dialog__body {
            padding: 24px;
        }

        .el-dialog__footer {
            padding: 14px 24px;
            border-top: 1px solid #e3f1ec;
        }
    }

    .import-tip {
        border-radius: 8px;
        margin-bottom: 18px;

        .import-tip-title {
            font-weight: 600;
            font-size: 14px;
        }

        .import-tip-body {
            font-size: 13px;
            line-height: 1.8;
            color: #606266;

            b {
                color: #2e8b74;
            }
        }
    }

    .import-uploader {
        ::v-deep .el-upload,
        ::v-deep .el-upload-dragger {
            width: 100%;
        }

        ::v-deep .el-upload-dragger {
            height: 140px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-color: #4fae93;

            .el-icon-upload {
                color: #2e8b74;
            }

            .el-upload__text {
                color: #606266;

                em {
                    color: #2e8b74;
                }
            }
        }
    }

    .import-result {
        margin-top: 18px;
        font-size: 14px;
        color: #303133;

        p {
            margin: 6px 0;
        }

        .ok {
            color: #2e8b74;
        }

        .skip {
            color: #e6a23c;
        }

        .import-skip-list {
            max-height: 160px;
            overflow-y: auto;
            margin-top: 8px;
            padding: 8px 12px;
            background: #fdf6ec;
            border-radius: 6px;
        }

        .import-skip-item {
            font-size: 13px;
            color: #e6a23c;
            line-height: 1.9;
        }
    }
}
</style>
